import {http} from "../http";
import {Company} from "../company";


export const getSalaryEmpDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/SALARY_EMP`);
    return data;
};

export const getDxaDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/DXA`);
    return data;
};

export const getOwnAccountDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/OWN_ACCOUNT`);
    return data;
};

export const getRwiftRubDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/SWIFT_RUB`);
    return data;
};

export const getEdvDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/EDV`);
    return data;
};

export const getIpsBdgDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/IPS_BDG`);
    return data;
};
export const getIpsNonBdgDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/IPS_OTH`);
    return data;
};
export const getIpsVatDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/IPS_VAT`);
    return data;
};

export const getInAccountDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/INTERNAL`);
    return data;
};

export const getHoksDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/XOHKS`);
    return data;
};

export const getSwiftDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/SWIFT`);
    return data;
};

export const getRubDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/SWIFT_RUB`);
    return data;
};

export const getExchangeDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/EXCHANGE`);
    return data;
};

export const getAzipsDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/AZIPS`);
    return data;
};

export const getGppDocumentNumber = async (company : Company): Promise<string> => {
    const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/GPP`);
    return data;
};

